import { render } from "./SettingsMenu.vue?vue&type=template&id=407836e6&ts=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=ts"
export * from "./SettingsMenu.vue?vue&type=script&lang=ts"

import "./SettingsMenu.vue?vue&type=style&index=0&id=407836e6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__